import React from 'react';
import { motion } from 'framer-motion';
import { OFFER_STEPS } from './offerData';

const OfferSteps: React.FC = () => (
  <section className="section-spacing relative bg-canvas overflow-hidden">

    <div className="relative container-site">
      <motion.div
        className="text-center mb-12"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.55, ease: 'easeOut' }}
      >
        <span className="inline-flex items-center gap-2 rounded-full border border-accent/35 bg-accent-strong/10 px-4 py-1.5 text-xs font-semibold tracking-wider text-accent-soft uppercase mb-4">
          Notre méthode
        </span>
        <h2 className="heading-section text-balance mb-2">
          Comment ça <span className="text-accent-soft">marche ?</span>
        </h2>
        <p className="text-fg-muted text-sm">Auto-entrepreneur, artisan ou TPE : de l'idée à la mise en ligne en 3 étapes simples</p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
        {OFFER_STEPS.map((step, index) => {
          const Icon = step.icon;
          return (
            <motion.div
              key={step.id}
              className="text-center p-6 md:p-7 rounded-2xl border border-line bg-surface backdrop-blur-sm"
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.35 }}
              transition={{ duration: 0.55, delay: index * 0.08, ease: 'easeOut' }}
              whileHover={{ y: -6, scale: 1.01 }}
            >
              <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-accent-strong/20 border border-accent/35 text-accent-soft">
                <Icon className="h-6 w-6" />
              </div>
              <span className="inline-flex rounded-full border border-accent/30 bg-accent-strong/10 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-accent-soft mb-3">
                Étape {step.id}
              </span>
              <h3 className="text-fg font-semibold mb-2">{step.title}</h3>
              <p className="text-fg-muted/90 text-sm leading-relaxed">{step.description}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);

export default OfferSteps;
